/**
 * DE: Euro in ganze Cent umrechnen, damit Summen ohne Rundungsfehler bleiben.
 * EN: Convert euros to whole cents so that sums stay free of rounding errors.
 */
export function toCents(euros: number): number {
  return Math.round(euros * 100);
}

/**
 * DE: Ganze Cent für die Ausgabe wieder in Euro umrechnen.
 * EN: Convert whole cents back to euros for output.
 */
export function toEuros(cents: number): number {
  return cents / 100;
}
